import { useRef, useState } from 'react';
import { $http } from '../../plugins';

export default (onComplete) => {
  const [loading, setLoading] = useState(false);
  const hiddenFileInput = useRef(null);
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    const uploadType = event.target.name;
    upload(fileUploaded, uploadType);
  };
  const upload = async (file, uploadType) => {
    try {
      setLoading(true);
      const fileUrl = URL.createObjectURL(file);
      const formData = new FormData();
      formData.append('File', file);
      formData.append('UploadType', 'MarketingPlanFormAttach');
      const res = await $http.post('/System/UploadAttachment', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      onComplete({
        name: file.name,
        attachmentCode: res.data,
        attachmentType: uploadType,
        refNo: '',
        refDate: '',
        path: fileUrl
      });
    } finally {
      setLoading(false);
    }
  };
  return { hiddenFileInput, handleClick, handleChange, loading };
};
